module.exports = __webpack_public_path__ + "img/points.52de6e1e.png";